import { render, staticRenderFns } from "./leftSidebar.vue?vue&type=template&id=4d09ec57&scoped=true&lang=pug&"
import script from "./leftSidebar.vue?vue&type=script&lang=ts&"
export * from "./leftSidebar.vue?vue&type=script&lang=ts&"
import style0 from "./leftSidebar.vue?vue&type=style&index=0&id=4d09ec57&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d09ec57",
  null
  
)

export default component.exports